/* eslint-disable import/prefer-default-export */
import {
  UPDATE_SCHEDULE,
  FETCH_SCHEDULE,
  LAST_WATERED,
  RUN_SCHEDULE,
  GET_CALENDAR_DATES,
  GET_SCHEDULE_FOR_DAY,
  GET_CURRENT_WATERING,
  MODIFY_SCHEDULE,
  NEW_SCHEDULE,
  DELETE_SCHEDULE,
  SET_CURRENT_WATERING,
  STOP_WATERING,
  SKIP_WATERING,
} from './types';

const updateScheduleAction = (payload) => ({
  type: UPDATE_SCHEDULE,
  payload,
});

const getScheduleAction = (payload) => ({
  type: FETCH_SCHEDULE,
  payload,
});

const getLastWateredAction = (payload) => ({
  type: LAST_WATERED,
  payload,
});

const runScheduleAction = (payload) => ({
  type: RUN_SCHEDULE,
  payload,
});

const getDatesAction = (payload) => ({
  type: GET_CALENDAR_DATES,
  payload,
});

const getScheduleForDayAction = (payload) => ({
  type: GET_SCHEDULE_FOR_DAY,
  payload,
});

const getCurrentWateringAction = (payload) => ({
  type: GET_CURRENT_WATERING,
  payload,
});

const setCurrentWateringAction = (payload) => ({
  type: SET_CURRENT_WATERING,
  payload,
});

const modifyScheduleAction = (payload) => ({
  type: MODIFY_SCHEDULE,
  payload,
});

const addScheduleAction = (payload) => ({
  type: NEW_SCHEDULE,
  payload,
});

const deleteScheduleAction = (payload) => ({
  type: DELETE_SCHEDULE,
  payload,
});

const stopWateringAction = (payload) => ({
  type: STOP_WATERING,
  payload,
});

const skipWateringAction = (payload) => ({
  type: SKIP_WATERING,
  payload,
});

export {
  updateScheduleAction,
  getScheduleAction,
  getLastWateredAction,
  runScheduleAction,
  getDatesAction,
  getScheduleForDayAction,
  getCurrentWateringAction,
  modifyScheduleAction,
  addScheduleAction,
  deleteScheduleAction,
  setCurrentWateringAction,
  stopWateringAction,
  skipWateringAction,
};
